/* globals ga */
require('jquery.iframetracker');
import $ from 'jquery';

export function setupGA() {
    $(document).ready(() => {
        $('.publication_iframe iframe').iframeTracker({
            blurCallback: () => dataLayer.push({"event": "iframe_play"}),
        });
    });
    $(document)
    .on('click', '.header_button--themes', e => dataLayer.push({"event": "menu-open"}))
    .on('click', '.carousel-nav', e => {
        if ("carouselEvent" in window) { // limit to one event per visit
            return
        } else {
            window["carouselEvent"] = 1
            dataLayer.push({"event": "galerie_photo_click", "label": window.location.pathname})
        }
    })
    .on('click', '.facebook-this', e => dataLayer.push({"event": "facebook-share"}))
    .on('click', '.email-this', e => dataLayer.push({"event": "email-share"}))
}



// WEBPACK FOOTER //
// ./entrypoints/iframetracker.js